// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"uiButton_colorPrimary__dfOlB","colorSecondary":"uiButton_colorSecondary__1n53o","container":"uiButton_container__1tlxB","root":"uiButton_root__1ZoWj","containerForDelete":"uiButton_containerForDelete__1DKGR","contained":"uiButton_contained__wkGMx","sizeSmall":"uiButton_sizeSmall__2y0Xm","outlined":"uiButton_outlined__2yir9","disabled":"uiButton_disabled__2rArb"};
    if(module.hot) {
      // 1744789617208
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  